import './PopupDialog.scss';
import Component from './PopupDialog';
export default Component;
